module.exports = __webpack_public_path__ + "static/careers-d3a279d4a46a5c85dfa0f226af82e771.svg";